export default __webpack_public_path__ + "static/Entenda0053-4570b237c0e5f7e0b47e54fe13819136.jpg";